<script>
  import { useForm } from '@inertiajs/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Field from '../../components/ui/Field.svelte';
  import Button from '../../components/ui/Button.svelte';

  const form = useForm({ name: '' });

  function submit() {
    form.transform((data) => ({ calendar: data })).post('/calendars');
  }
</script>

<AppLayout title="New calendar">
  <div class="max-w-md">
    <Card>
      <form onsubmit={(e) => { e.preventDefault(); submit(); }} class="flex flex-col gap-5">
        <Field label="Name" id="name" error={form.errors.name}>
          {#snippet children(describedBy)}
            <input id="name" type="text" class="input" bind:value={form.name} placeholder="e.g. Acme Corp" required aria-describedby={describedBy} />
          {/snippet}
        </Field>

        <div class="flex items-center gap-3">
          <Button type="submit" disabled={form.processing}>{form.processing ? 'Creating…' : 'Create calendar'}</Button>
          <Button href="/calendars" variant="ghost">Cancel</Button>
        </div>
      </form>
    </Card>
  </div>
</AppLayout>
